module.exports = __webpack_public_path__ + "img/Schebesta.589df814.jpeg";